module.exports = __webpack_public_path__ + "angular.2ctZPugm.svg";